var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23319_42565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10388 5.30443L10.0003 9.20089L13.8968 5.30442C14.1175 5.08375 14.4753 5.08375 14.6959 5.30442C14.9166 5.5251 14.9166 5.88291 14.6959 6.10358L10.7995 10L14.6959 13.8965C14.9166 14.1172 14.9166 14.475 14.6959 14.6956C14.4753 14.9163 14.1175 14.9163 13.8968 14.6956L10.0003 10.7992L6.10388 14.6956C5.88321 14.9163 5.52541 14.9163 5.30474 14.6956C5.08407 14.475 5.08407 14.1172 5.30474 13.8965L9.20118 10L5.30473 6.10359C5.08405 5.88292 5.08405 5.52511 5.30473 5.30443C5.5254 5.08376 5.88321 5.08376 6.10388 5.30443Z",
    fill: "#A7B2AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23319_42565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(1.66699 1.66675)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantCross);
export default __webpack_public_path__ + "static/media/ai_assistant_cross.f89c01ad9016cad82c410189cf79a847.svg";
export { ForwardRef as ReactComponent };